import { Component, OnInit, Input } from '@angular/core';
import { StorageManagerService } from '../../shared/services/index';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { BaseAccordionComponent } from '../base-accordion/base-accordion.component';

@Component({
    selector: 'app-product-designer',
    templateUrl: './product-designer.component.html',
    styleUrls: ['./product-designer.component.scss'],
    standalone: false
})
export class ProductDesignerComponent extends BaseAccordionComponent implements OnInit {

  constructor (public fb: FormBuilder, public storage: StorageManagerService) {

    super(fb, storage);
   }

  ngOnInit() {

    this.dataScope = this.storage.read('dataScope');

    this.initializeMainForm();

    this.patchForms();
  }

  initializeMainForm() {

    this.deviceForm = this.fb.group({
      productDesignerSRN: ['', { validators: [] }],
      streetName: ['', { validators: [] }],
      streetNumber: ['', { validators: [] }],
      addressComplement: ['', { validators: [] }],
      poBox: ['', { validators: [] }],
      city: ['', { validators: [] }],
      postalCode: ['', { validators: [] }],
      country: ['', { validators: [] }],
      designerForm: this.fb.array([this.addDesignerForm()]),
      publicContactForm: this.fb.array([this.addPublicContactForm()])
    });

    // Watch changes on the entire deviceForm
    this.deviceForm.valueChanges.subscribe(data => {
      this.logValidationErrors(this.deviceForm);
  });
  }

  get designerForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('designerForm');
  }

  get publicContactForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('publicContactForm');
  }

  addDesignerForm(): FormGroup {

    return this.fb.group({
      name: ['', { validators: [] }],
      language: ['', { validators: [] }]
    });
  }

  addPublicContactForm(): FormGroup {

    return this.fb.group({
      email: ['', { validators: [] }],
      phone: [this.fb.array([])]
    });
  }

  patchForms() {

    this.deviceForm.patchValue({

      productDesignerSRN: this.displayItemData('Product Designer SRN'),
      streetName: this.displayItemData('Street Name'),
      streetNumber: this.displayItemData('Street Number'),
      addressComplement: this.displayItemData('Address Complement'),
      poBox: this.displayItemData('PO Box'),
      city: this.displayItemData('City'),
      postalCode: this.displayItemData('Postal Code'),
      country: this.displayItemData('Country')
    });

    this.deviceForm.setControl('designerForm', this.setDesignerForm());
    this.deviceForm.setControl('publicContactForm', this.setPublicContactForm());

  }

  setDesignerForm(): FormArray {

    const formArray = new FormArray([]);

    let item: any;

    item = this.displayItemData('Product Designer Names');

    if (item && item.length > 0) {
      item.forEach((c, i) => {
          formArray.push(

                this.fb.group({
                  name: c[(this.getMapInnerPathName('PD Name'))[0]],
                  language: c[(this.getMapInnerPathName('PD Language'))[0]]
                })
            );
        });
    }

    return formArray;
  }

  setPublicContactForm(): FormArray {

    const formArray = new FormArray([]);

    let item: any;

    item = this.displayItemData('Product Designer Contacts');

    if (item && item.length > 0) {
      item.forEach((c, i) => {
          formArray.push(

                this.fb.group({
                  email: c[(this.getMapInnerPathName('Email'))[0]],
                  telephone: c[(this.getMapInnerPathName('Telephone'))[0]]
                })
            );
        });
    }

    return formArray;
  }
}
